import parsers from './errors/parsers';

/*
parser for URQL combined error objects
https://github.com/FormidableLabs/urql/blob/master/docs/api.md#combinederror-class

Each imported parser is setup to catch a specific set/type of error(s). The order of the parsers is
important. A single error may "match" multiple parsers but we are only concerned with the first
*/
const errorParserWithValidation = rawError => {
  if (!rawError) return undefined;

  const errorParser = Object.values(parsers).find(parser => parser(rawError).hasErrors());
  return errorParser ? errorParser(rawError).parse() : undefined;
};

export default errorParserWithValidation;
